/**
 * Returns the character at the specified index.
 * @param index — The zero-based index of the desired character.
 */
export function charAt(index: number) {
  return (string: string) => string.charAt(index)
}
